var map = {
	"./afe/custom.json": 69935,
	"./apin/custom.json": 63789,
	"./aveiro/custom.json": 31037,
	"./cadaval/custom.json": 99051,
	"./carrazeda/custom.json": 6138,
	"./cidadepraia/custom.json": 32320,
	"./fcolmeiasememoria/custom.json": 32859,
	"./mirandadouro/custom.json": 44382,
	"./mirandela/custom.json": 14572,
	"./mogadouro/custom.json": 63544,
	"./oaz/custom.json": 13551,
	"./oeiraseu/custom.json": 45616,
	"./proenca/custom.json": 28445,
	"./rgrande/custom.json": 49448,
	"./rnps/custom.json": 95744,
	"./rnps/theme/custom.json": 46238,
	"./serpa/custom.json": 90090,
	"./smartcity/custom.json": 87451,
	"./valpacos/custom.json": 83418,
	"./vcambra/custom.json": 47305,
	"./vilaflor/custom.json": 24360,
	"./vilaverde/custom.json": 43937,
	"./vimioso/custom.json": 17595,
	"./vinhais/custom.json": 17883,
	"./vvrodao/custom.json": 3114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6770;